import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  createStyles,
  Theme,
  Typography,
  WithStyles,
  withStyles
} from "@material-ui/core";
import { blue } from "@material-ui/core/colors";
import * as React from "react";

interface MainProps extends WithStyles<typeof styles> {}

const NAV_ITEMS = [
  {
    title: "Participant",
    url: window.location.href.includes("gwbri")
      ? "https://participant.gwbri.org/"
      : "https://participant.dev-ridlt.net",
    description: "I am enrolling in a Real Jobs or Real Pathways program"
  },
  {
    title: "Enrollment Manager",
    url: window.location.href.includes("gwbri")
      ? "https://enrollment.gwbri.org/"
      : "https://enrollment.dev-ridlt.net",
    description:
      "That needs access to my Enrollment Console to access an activity code, " +
      "update a participants information, or assist a participant in enrolling."
  }
];

const Main: React.SFC<MainProps> = (props: MainProps) => {
  const { classes } = props;

  return (
    <div className={classes.root}>
      <Typography
        component="h1"
        variant="h5"
        align="center"
        className={classes.title}
      >
        I am a:
      </Typography>

      <section className={classes.cards}>
        {NAV_ITEMS.map((item, index) => (
          <Card className={classes.card} key={index}>
            <a href={item.url} style={{ textDecoration: "none" }}>
              <CardActionArea>
                <CardHeader
                  className={classes.cardHeader}
                  title={item.title}
                  titleTypographyProps={{
                    component: "h2",
                    variant: "h5",
                    align: "center",
                    color: "inherit"
                  }}
                />
                <CardContent>
                  <Typography component="p">{item.description}</Typography>
                </CardContent>
              </CardActionArea>
            </a>
          </Card>
        ))}
      </section>
    </div>
  );
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "0 auto",

      [theme.breakpoints.up("lg")]: {
        width: "70%"
      },
      [theme.breakpoints.up("md")]: {
        width: "80%"
      },
      [theme.breakpoints.only("sm")]: {
        width: "65%"
      },
      [theme.breakpoints.only("xs")]: {
        width: "90%"
      }
    },
    title: {
      paddingBottom: theme.spacing.unit * 3
    },
    roleSection: {},
    cards: {
      display: "flex",
      justifyContent: "space-evenly",

      [theme.breakpoints.down("sm")]: {
        flexDirection: "column"
      }
    },
    card: {
      flexBasis: "45%",

      [theme.breakpoints.down("sm")]: {
        flexBasis: "96%",
        marginBottom: theme.spacing.unit * 3
      }
    },
    cardHeader: {
      backgroundColor: blue[700],
      color: "white"
    }
  });

export default withStyles(styles)(Main);



// WEBPACK FOOTER //
// ./src/components/Main/Main.tsx